import { gate } from 'hub-http/gates';
import Raven from 'raven-js';
import identity from 'transmute/identity';
import { evaluateProposedRulesRpc } from '../../../__generated__/chirp/com/hubspot/property/validation/rpc/PropertyValidationRpc';
import { InMemoryCache } from '../InMemoryCache';
const VALID_EMAIL = {
  isValid: true,
  error: null,
  message: null
};
const fetchValidateEmail = (email, httpClient) => {
  return httpClient.post('property-validation/v1/property-validation/evaluate-proposed-rules', {
    data: {
      proposedRules: [{
        ruleType: 'EMAIL',
        ruleArguments: []
      }],
      proposedValue: email
    }
  }).then(result => {
    if (result.length > 0) {
      return result[0];
    }
    return VALID_EMAIL;
  }).catch(error => {
    Raven.captureException(error, {
      extra: {
        email
      }
    });
  });
};
const fetchValidateEmailChirp = (email, rpcClient) => {
  return rpcClient.call(evaluateProposedRulesRpc, {
    request: {
      proposedRules: [{
        ruleType: 'EMAIL',
        ruleArguments: []
      }],
      proposedValue: email
    }
  }).then(response => {
    var _response$validationR;
    const first = (_response$validationR = response.validationResults) === null || _response$validationR === void 0 ? void 0 : _response$validationR[0];
    if (!first) {
      return VALID_EMAIL;
    }
    return {
      isValid: first.isValid,
      error: typeof first.error === 'string' && first.error !== 'NO_ERROR' ? first.error : null,
      message: first.message || null
    };
  }).catch(error => {
    Raven.captureException(error, {
      extra: {
        email
      }
    });
  });
};
export const makeEmailValidationCache = () => new InMemoryCache('EmailValidationCache', identity, ({
  httpClient,
  rpcClient,
  getIsUngated
}) => email => getIsUngated(gate('CRM:Properties:PropertyValidationChirp')) ? fetchValidateEmailChirp(email, rpcClient) : fetchValidateEmail(email, httpClient));